import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import numeral from 'numeral'
import Tooltip from 'orionsoft-parts/lib/components/Tooltip'

export default class Rut extends React.Component {
  static propTypes = {
    value: PropTypes.object,
    onChange: PropTypes.func,
    field: PropTypes.object
  }

  state = {valid: false}

  onInputChange(event) {
    if (event.length < 3) {
      this.setState({valid: false})
      this.props.onChange(event)
      return
    }
    var numbers = event.replace(/[^\dkK]/g, '')
    this.validate(numbers, event)
    var parts = numbers.split('')
    if (parts.length === 0) return numbers
    var last = parts.pop()
    if (parts.length === 0) return numbers
    var final = numeral(parts.join('')).format('0,0') + '-' + last
    final = final.replace(/,/g, '.')
    this.props.onChange(final)
  }

  validate(valor, event) {
    valor = valor.replace('-', '')
    let cuerpo = valor.slice(0, -1)
    let dv = valor.slice(-1).toUpperCase()
    if (cuerpo.length < 7) {
      return false
    }
    let suma = 0
    let multiplo = 2
    for (let i = 1; i <= cuerpo.length; i++) {
      let index = multiplo * valor.charAt(cuerpo.length - i)
      suma = suma + index
      if (multiplo < 7) {
        multiplo = multiplo + 1
      } else {
        multiplo = 2
      }
    }
    let dvEsperado = 11 - suma % 11
    dv = dv === 'K' ? 10 : dv
    dv = dv === 0 ? 11 : dv
    if (String(dvEsperado) !== String(dv)) {
      this.setState({valid: false})
      return false
    }
    this.setState({valid: true})
    return true
  }

  renderInformation() {
    let required = '(Opcional)'
    if (!this.props.field) return null
    if (this.props.field.required) {
      required = '(Requerido)'
    }
    if (this.props.field.name) {
      return `${this.props.field.name} ${required}`
    }
    if (this.props.field.validation) {
      return `${this.props.field.validation} ${required}`
    }
    return `Texto ${required}`
  }

  messageField() {
    if (this.props.field.required) {
      if (this.state.valid) return 'Todo se ve bien (Requerido)'
      return 'Información no válida (Requerida)'
    }
    if (this.state.valid) return 'Todo se ve bien (Opcional)'
    return 'Información no válida (Opcional)'
  }

  renderClassName(textSize) {
    let mStyle = "";
    if (this.props.field.required) {
      if (this.state.valid) 
        mStyle = styles.requiredValid
      else
        mStyle = styles.requiredInvalid
    } else {
      if (this.state.valid) 
        mStyle = styles.noRequiredValid
      else 
        mStyle = styles.noRequiredInvalid
    }
    if(textSize==='medium')
      mStyle += ' ' + styles.medium
    else if(textSize==='large')
      mStyle += ' ' + styles.large
    else
      mStyle += ' ' + styles.small

    return mStyle;
  }

  render() {
    return (
      <Tooltip content={this.messageField()}>
        <input
          type={'text'}
          maxLength="12"
          placeholder={this.renderInformation()}
          value={this.props.value ? this.props.value.text : ''}
          onChange={event => this.onInputChange(event.target.value)}
          className={this.renderClassName(this.props.field.textSize)}
          id={this.props.field.id}
          data-filled={this.props.value ? 'true' : 'false'}
          data-filler={this.props.field && this.props.field.filler}
          data-required={this.props.field && this.props.field.required ? 'true' : 'false'}
        />
      </Tooltip>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Sign/Document/Page/Field/Edit/Rut/index.js